angular.module('homebot.directives')

.directive('learnMoreMortgage', ['$rootScope', function($rootScope){
  return {
    restrict: 'A',
    controllerAs: 'learnCtrl',
    bindToController: {
      loans: '=',
      agent: '=',
      phoneTrack: '@',
      emailTrack: '@',
    },
    scope: {},
    transclude: true,
    templateUrl: '/homes/templates/partials/learn-more-mortgage.html',
    controller: function(){
      const ctrl = this;

      ctrl.openDisclaimerModal = function() {
        $rootScope.$broadcast('openDisclaimerModal', true);
      };
    }
  }
}]);
